// extracted by mini-css-extract-plugin
export var circle = "ScrollDownCircle-module--circle--26q2x";
export var Animation = "ScrollDownCircle-module--Animation--3tNMC";
export var afterWave = "ScrollDownCircle-module--afterWave--3vMeM";
export var indend1 = "ScrollDownCircle-module--indend1--5_EpJ";
export var indend2 = "ScrollDownCircle-module--indend2--OyZjY";
export var spinAround = "ScrollDownCircle-module--spinAround--1GZzJ";